module.exports = __webpack_public_path__ + "media/icons/tapicerka-materialowa-active@3x-15b7915e.svg";